import { Component } from 'shimmer'

import {
  PlaneGeometry,
  MeshNormalMaterial,
  MeshStandardMaterial,
  Mesh
} from 'three'

import { webGL } from '@/webGL/WebGL'

import { MeshReflectorMaterial } from '@/webGL/materials/MeshReflectorMaterial'

export class Floor extends Component {
  constructor () {
    super()

    this.object = new Mesh(new PlaneGeometry(40, 100))
    this.object.material = new MeshReflectorMaterial(webGL.renderer.renderer, webGL.camera, webGL.scene, this.object, {
      resolution: 1024,
      blur: [512, 128],
      mixBlur: 2.5,
      mixContrast: 1,
      mirror: 1
    })
    this.object.rotation.x = -Math.PI * .5
    this.object.position.y = -5

    this.adder = .001

    this.add(this.object)
  }

  onUpdate() {
    this.object.material.update()

    this.object.rotation.y += this.adder

    if (Math.abs(this.object.rotation.y) > .2) {
      this.adder *= -1
    }
  }
}